import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { ContextTag } from '../wiki/Wiki'
import { GeoLayer, AbstractLayer, AbstractLayerOptions, SwitchSubLayers } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the HydroModel layers.
 */
class HydroModelLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5,
    switchSubLayers: {
      labelId: 'layerpicker.switchsublayer',
      sublayers: []
    }
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.HYDRO_MODEL,
      enabled: true,
      minZoom: 7,
      zIndex: 3
    }
    super({ ...defaultOptions, ...options })

    let { switchSubLayers, opacity } = options.params
    opacity = opacity === undefined ? HydroModelLayer.defaultParams.opacity : opacity
    const subLayers = (switchSubLayers as SwitchSubLayers)?.sublayers
      .filter(subLayer => subLayer.enabled)
      .map(subLayer => subLayer.subLayer)
      .reverse()

    if (subLayers.length > 0) {
      this.olLayer = new ol.layer.Image({
        visible: this.enabled,
        opacity: opacity,
        source: new ol.source.ImageWMS({
          url: 'https://data.geo.dk/mapv2/geo-hydromodels/wms',
          params: {
            layers: subLayers,
            token: options.token
          },
          projection: new ol.proj.Projection({
            code: 'EPSG:25832'
          }),
        })
      })
    } else {
      // No sublayers are active.
      // We need a layer here, so we simply create an empty Vector layer.
      // There's no overhead in that.
      this.olLayer = new ol.layer.Vector()
    }
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.HYDRO_MODEL,
      name: 'map.layer.hydromodels',
      group: LayerGroup.WATER,
      contextTags: [
        ContextTag.HYDROMODEL
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default HydroModelLayer
